export default async function sendChamados(chamadoData) {
    console.log("Enviando chamado:", chamadoData); // Log para depuração
    try {
        // Faz a requisição POST para o endpoint /sendChamados
        const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/sendChamados`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(chamadoData), // Dados do chamado enviados no corpo da requisição
        });

        // Verifica se a resposta foi bem-sucedida
        if (!response.ok) {
            throw new Error(`Erro ao enviar chamado: ${response.statusText}`);
        }

        // Retorna a resposta da API como JSON
        const data = await response.json();

        return data; // Retorna os dados recebidos da API
    } catch (error) {
        console.error("Erro ao enviar chamado:", error.message);
        return { success: false, message: error.message }; // Retorna um objeto padrão em caso de erro
    }
}
